import { render, staticRenderFns } from "./AddAssetsDialog.vue?vue&type=template&id=3a1a0d50&"
import script from "./AddAssetsDialog.vue?vue&type=script&lang=ts&"
export * from "./AddAssetsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VExpandTransition,VFlex,VForm,VImg,VLayout,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1a0d50')) {
      api.createRecord('3a1a0d50', component.options)
    } else {
      api.reload('3a1a0d50', component.options)
    }
    module.hot.accept("./AddAssetsDialog.vue?vue&type=template&id=3a1a0d50&", function () {
      api.rerender('3a1a0d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/assets/AddAssetsDialog.vue"
export default component.exports